// @ts-nocheck

import { PageContainer } from 'components/Container';
import { useIsAuthenticated } from 'lib/hooks/useIsAuthenticated';
import dynamic from 'next/dynamic';
import * as React from 'react';

const NoSSRContentWrapper = dynamic(() => import('../ContentUI/NoSSRComp'), {
  ssr: false,
});

interface CMSPageProps {
  pageUrl: string;
  title: string;
}

function CMSPage({ pageUrl, title }: CMSPageProps) {
  const isAuthenticated = useIsAuthenticated();

  return (
    <PageContainer
      cmsContent
      breadcrumbs={[
        {
          href: isAuthenticated ? '/dashboard' : '/',
          title: isAuthenticated ? 'Dashboard' : 'Home',
        },
        {
          href: `/${pageUrl}`,
          title: title,
        },
      ]}
      title={title}
    >
      {
        // eslint-disable-next-line @typescript-eslint/ban-ts-ignore
        // @ts-ignore
        <NoSSRContentWrapper projectId={process.env.REACT_APP_PROJECT_ID} contentPageUrl={pageUrl} />
      }
    </PageContainer>
  );
}

export default CMSPage;
